/**
 * Resolve the document/window an element actually lives in. Components that
 * can be portaled into a popped-out window (see shared/PopoutWindow) must not
 * assume the global `document`/`window`: menus portaled to the parent's body,
 * listeners bound to the parent's document and viewport math against the
 * parent's window all break there. Pass a ref to any rendered node.
 */
export function ownerDocumentOf(el: Element | null | undefined): Document {
  return el?.ownerDocument ?? document;
}

export function ownerWindowOf(el: Element | null | undefined): Window {
  return el?.ownerDocument?.defaultView ?? window;
}
